export default function SuccessPage() {
  const sessionId = new URLSearchParams(window.location.search).get(
    "session_id"
  );

  // get clientId
  const clientSessionKey = "motomate_client_session_id";
  const clientId = window.localStorage.getItem(clientSessionKey);

  // if there is a clientId, call /api/success to notify backend
  if (clientId && sessionId) {
    fetch("/api/success", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sessionId, clientId }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Display this data in the UI by setting state
        // console.log("Success:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <h1 style={{ color: "#4CAF50" }}>Payment Successful! ✅</h1>
      <p>Click the button below to confirm your reservation.</p>
      <p style={{ color: "#666" }}>Session ID: {sessionId}</p>
      <button
        onClick={() => window.close()}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007cba",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Confirm Reservation
      </button>
    </div>
  );
}
